import React from 'react'
import './styles.scss'

interface ButtonProps {
  children: React.ReactNode
  onClick?: () => void
  className?: string
  disabled?: boolean
}

const Button = ({
  children,
  onClick,
  className = '',
  disabled = false
}: ButtonProps): JSX.Element => {
  const baseClass = ['Button', className, disabled ? 'is-disabled' : '']
    .filter(Boolean)
    .join(' ')

  return (
    <button
      className={baseClass}
      onClick={onClick}
      disabled={disabled}
      type='button'
    >
      {children}
    </button>
  )
}

export default Button
